export const measure = (props) => {
    const { $width, $height, $maxWidth, $minWidth, $minHeight, $maxHeight } = props;
    return `
    ${$width ? `width: ${$width};` : ''}
    ${$maxWidth ? `max-width: ${$maxWidth};` : ''}
    ${$minWidth ? `min-width: ${$minWidth};` : ''}
    ${$height ? `height: ${$height};` : ''}
    ${$minHeight ? `min-height: ${$minHeight};` : ''}
    ${$maxHeight ? `max-height: ${$maxHeight};` : ''}
  `;
};
//# sourceMappingURL=measure.js.map